<template>
  <div>
    <div class="row mb-4">
      <div class="col-12 text-center">
        <ul v-if="$route.path === '/branches'" class="nav-menu">
          <li @click="changeOption($event, 5)">
            <a id="company-menu">
              {{ $t('menu.settings.accountData.branch') }}
            </a>
          </li>
          <li @click="changeOption($event, 6)">
            <a id="company-users">
              {{ $t('menu.settings.accountData.ih2') }}
            </a>
          </li>
        </ul>
        <ul v-if="$route.path === '/alerts-bulletins'" class="nav-menu">
          <li @click="changeOption($event, 7)">
            <a id="company-menu">{{
              this.$t('menu.settings.alertsNewsletters.alerts')
            }}</a>
          </li>
          <li @click="changeOption($event, 8)">
            <a id="company-users">{{
              this.$t('menu.settings.alertsNewsletters.bulletin')
            }}</a>
          </li>
        </ul>
        <ul class="nav-menu" v-if="$route.path === '/settings'">
          <li
            v-if="userAuth.type !== 'analyst'"
            @click="changeOption($event, 1)"
          >
            <a id="company-menu">{{
              $t('menu.settings.accountData.myCompany')
            }}</a>
          </li>
          <li @click="changeOption($event, 2)">
            <a id="company-users">{{
              $t('menu.settings.accountData.consumptionDetails')
            }}</a>
          </li>
          <li @click="changeOption($event, 4)">
            <a id="company-categories">{{
              $t('menu.settings.accountData.categories')
            }}</a>
          </li>
          <li @click="changeOption($event, 9)">
            <a id="company-templates">{{
              $t('menu.settings.accountData.templates')
            }}</a>
          </li>
          <li @click="changeOption($event, 10)">
            <a id="company-tags">Tags tratativas</a>
          </li>
          <li @click="changeOption($event, 11)">
            <a id="company-tags">Status tratativas</a>
          </li>
          <li @click="changeOption($event, 12)">
            <a id="company-tags">Regras de tratativas</a>
          </li>
          <li @click="changeOption($event, 13)" v-if="userAuth  && (userAuth.permissions.type === 'admin' || userAuth.permissions.type === 'master') ">
            <a id="company-filters">Filtros personalizados</a>
          </li>
          <li @click="changeOption($event, 14)">
            <a id="company-logs">Registro de auditoria</a>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="$route.path === '/settings'">
      <div v-if="step === 1">
        <configCompany />
      </div>
      <div v-if="step === 2">
        <consumption />
      </div>
      <div v-if="step === 4">
        <add-categories />
      </div>
      <div v-if="step === 9">
        <default-templates />
      </div>
      <div v-if="step === 10">
        <treatments-tags />
      </div>
      <div v-if="step === 11">
        <treatments-status />
      </div>
      <div v-if="step === 12">
        <treatments-rules />
      </div>
      <div v-if="step === 13">
        <custom-filter-date />
      </div>
      <div v-if="step === 14">
        <company-logs />
      </div>
    </div>

    <div v-if="$route.path === '/branches'">
      <div v-if="step === 5">
        <branchesIh1 />
      </div>
      <div v-if="step === 6">
        <branchesIh2 />
      </div>
    </div>
    <div v-if="$route.path === '/alerts-bulletins'">
      <div v-if="step === 7">
        <alerts />
      </div>
      <div v-if="step === 8">
        <bulletins />
      </div>
    </div>
  </div>
</template>

<script>
import addCategories from '@/components/molecules/add-categories';
import defaultTemplates from '@/components/molecules/default-templates';
import treatmentsStatus from '@/components/molecules/treatments-status';
import treatmentsRules from '@/components/molecules/treatments-rules';
import customFilterDate from '@/components/molecules/custom-filter-date';
import treatmentsTags from '@/components/molecules/treatments-tags';
import configCompany from '@/components/molecules/config-company';
import companyLogs from '@/components/molecules/log-recording';
import consumption from '../../consumption-details';
import branchesIh1 from '../branches';
import branchesIh2 from '../ih2';
import alerts from '../settings-alert-rules';
import bulletins from '../bulletins';

export default {
  components: {
    addCategories,
    configCompany,
    consumption,
    branchesIh1,
    branchesIh2,
    alerts,
    bulletins,
    defaultTemplates,
    treatmentsTags,
    treatmentsStatus,
    treatmentsRules,
    customFilterDate,
    companyLogs,
  },

  watch: {
    '$route.path': function watchPath() {
      this.handleConfigPath();

      if (this.step === 1 || this.step === 5 || this.step === 7) {
        document.getElementById('company-menu').classList.add('menu-active');
        document
          .getElementById('company-users')
          .classList.remove('menu-active');
      }
    },
  },

  data: () => ({
    userAuth: null,
    step: null,
  }),

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (this.userAuth.type === 'analyst') {
      this.step = 4;
    } else {
      this.step = 1;
    }

    this.handleConfigPath();
  },

  mounted() {
    if (this.$route.params.settings === 'add-category') {
      this.step = 4;
    }

    if (this.$route.params.settings === 'add-tag') {
      this.step = 10;
    }

    if (this.step === 1) {
      document.getElementById('company-menu').classList.add('menu-active');
    } else if (this.step === 2) {
      document.getElementById('company-users').classList.add('menu-active');
    } else if (this.step === 5 || this.step === 7) {
      document.getElementById('company-menu').classList.add('menu-active');
    } else if (this.step === 4) {
      document
        .getElementById('company-categories')
        .classList.add('menu-active');
    } else if (this.step === 9) {
      document.getElementById('company-templates').classList.add('menu-active');
    } else if (this.step === 14){
      document.getElementById('company-logs').classList.add('menu-active');
    } else {
      document.getElementById('company-tags').classList.add('menu-active');
    }
  },

  methods: {
    handleConfigPath() {
      if (this.$route.path === '/settings') {
        this.step = 1;
      } else if (this.$route.path === '/branches') {
        this.step = 5;
      } else if (this.$route.path === '/alerts-bulletins') {
        this.step = 7;
      }
    },
    changeOption(event, step) {
      const $li = document.querySelector('.menu-active');
      $li.classList.remove('menu-active');
      event.target.classList.add('menu-active');
      this.step = step;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.nav-menu {
  list-style-type: none;
  margin: 0;
  padding: 0;

  li {
    display: inline;
  }

  a {
    padding: 10px;
    &:hover {
      cursor: pointer;
    }
  }

  .menu-active {
    border-bottom: 2px solid $primary;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/general-settings/index.vue